import ko from './ko';

const en = {
  ...ko,
  lang: 'en',
  langName: 'English',
  flag: '🇺🇸',
  siteTitle: 'Free TOEFL Mock Test 2026 — Start without signup | Power TOEFL',
  siteDescription: 'Free TOEFL iBT practice for the Jan 2026 format: Reading 50/30 min, Listening 47/29, Listen and Repeat, email writing. Scores 1–6. Independent, not ETS.',
  ogTitle: 'Free TOEFL Mock Test 2026 — Start without signup | Power TOEFL',

  navGrammar: 'Grammar',
  navPractice: 'Section Practice',
  navScoreChart: 'Score Chart',
  navVocabulary: 'Vocabulary',
  navTips: 'Tips & Strategy',
  navQuestionPool: 'Question Bank',
  navResources: 'Resources',
  navSpeaking: 'Speaking',
  navWriting: 'Writing',
  navPremium: 'Premium',

  loginButton: 'Log in',
  wrongAnswers: 'Error Notebook',
  logout: 'Log out',
  loginRequired: 'Login is required for Error Notebook and Resume features.',
  googleLogin: 'Continue with Google to unlock premium features',

  heroBadge: '2026 format · start without signup',
  heroTitle1: 'One Platform',
  heroTitle2: 'for High TOEFL Scores',
  heroDesc1: 'Free TOEFL mock test. Reading 50/30 min, Listening 47/29, Listen and Repeat, email writing.',
  heroDesc2: 'Not ETS. Practice scores 1–6. Start without an account.',

  lcTitle: 'Listening',
  lcSubtitle: 'Listening — 47 questions',
  lcTime: '29 min',
  rcTitle: 'Reading',
  rcSubtitle: 'Reading — 50 questions',
  rcTime: '30 min',
  startTest: 'Start Test',
  fullTestStart: 'Start Full Mock Test (Reading -> Listening)',
  fullTestDesc: 'Complete both sections in sequence',

  part1: 'Academic Reading (20)',
  part2: 'Conversations (10)',
  part3: 'Lectures (18)',

  moreTools: 'More Learning Tools',
  practiceLabel: 'Section Practice',
  practiceDesc: 'Train Reading and Listening separately',
  scoreChartLabel: 'Score Conversion',
  scoreChartDesc: 'Correct answers to converted score',
  vocabLabel: 'Vocabulary',
  vocabDesc: 'Essential TOEFL vocabulary',
  tipsLabel: 'Tips & Strategy',
  tipsDesc: 'Listening and Reading playbook',
  catLabel: 'CAT Adaptive Test',
  catDesc: 'Difficulty auto-adjusts to your level',
  guideLabel: 'Study Guides',
  guideDesc: 'Skill-based strategies, score-band plans, and exam comparisons',
  fullTestCardLabel: 'Full Mock Test',
  fullTestCardDesc: 'Realistic Reading + Listening practice',
  grammarSectionTitle: 'English Grammar Book',
  grammarSectionDesc: 'Build TOEFL grammar fundamentals step by step',
  grammarViewAll: 'View all',
  proBadgeLabel: 'Pro',

  statQuestions: 'Questions',
  statParts: 'Parts',
  statMinutes: 'Minutes',

  footerMockTest: 'Practice',
  footerQuestionPool: 'Question Bank',
  footerPractice: 'Section Practice',
  footerStudy: 'Study',
  footerBooks: 'Recommended Books',
  footerEtc: 'More',
  footerLC: 'Listening Practice',
  footerRC: 'Reading Practice',
  footerSpeaking: 'Speaking Practice',
  footerWriting: 'Writing Practice',
  footerLCStrategy: 'Listening Strategy',
  footerRCStrategy: 'Reading Strategy',
  footerCopyright: '© 2026 Power TOEFL. All rights reserved.',
  footerDisclaimer: 'TOEFL® is a registered trademark of ETS. Power TOEFL is an independent platform and is not affiliated with or endorsed by ETS.',

  faqTitle: 'Frequently Asked Questions',
  faqDesc: 'Find answers about TOEFL and Power TOEFL.',
  faqPageTitle: 'TOEFL Registration, Score, Validity - 2026 FAQ | Power TOEFL',
  faqPageDesc: 'Registration, score conversion, validity, and section strategy in one page.',
  faqMore: 'Need more help? We keep updating this FAQ.',

  scoreChartPageTitle: 'TOEFL Score Conversion 2026 - Check Section Scores Instantly | Power TOEFL',
  scoreChartPageDesc: 'TOEFL section score conversion for Reading, Listening, Speaking, Writing. Enter correct answers for estimated score and target guidance.',
  scoreChartHeading: 'TOEFL Score Conversion Chart',
  scoreChartIntro: 'These 0-30 section and 0-120 total tables are Power TOEFL study estimates on the legacy/comparable scale. Official 2026 reports lead with section and overall scores from 1-6 in half-point increments.',
  scoreChartLC: 'Reading Conversion',
  scoreChartRC: 'Listening Conversion',
  scoreChartCorrect: 'Correct',
  scoreChartConverted: 'Converted Score',
  scoreChartUnit: '',
  scoreChartPointUnit: 'pts',
  scoreGuideTitle: 'Target Score Guide',
  scoreGuide900: 'Top Tier',
  scoreGuide900Desc: 'Target 28+ per section. Strong for top admissions.',
  scoreGuide800: 'Upper Tier',
  scoreGuide800Desc: 'Target 22+ per section. Meets most admission requirements.',
  scoreGuide700: 'Upper-Intermediate',
  scoreGuide700Desc: 'Academic baseline achieved. Conditional admission possible.',
  scoreGuide600: 'Intermediate',
  scoreGuide600Desc: 'Focus on Reading and Listening fundamentals first.',
  scoreGuideDescs: [
    'Reading 28+ / Listening 28+ / Speaking 26+ / Writing 26+ recommended. Competitive for top-tier admissions.',
    'Target Reading 22+ / Listening 22+. Meets most admission requirements.',
    'Academic baseline reached. Conditional admission may be possible with focused study.',
    'Foundation stage. Prioritize Reading and Listening basics first.',
  ],
  scoreChartFaqTitle: 'TOEFL Score FAQ',
  scoreChartCtaTitle: 'Check your level now',
  scoreChartCtaDesc: 'Take a free TOEFL mock test and estimate your score.',
  scoreReadingHeader: 'Reading (0-30 pts)',
  scoreListeningHeader: 'Listening (0-30 pts)',
  scoreSpeakingHeader: 'Speaking (0-30 pts)',
  scoreWritingHeader: 'Writing (0-30 pts)',
  scoreSpeakingDesc: '4 tasks are scored on a 0-4 scale, then converted to 30 points',
  scoreWritingDesc: '2 tasks are scored on a 0-5 scale, then converted to 30 points',
  scoreSpeakingLevels: [
    ['4 (Good)', '27-30 pts', 'Fluent and accurate responses with clear logic'],
    ['3 (Fair)', '19-26 pts', 'Mostly clear with some errors'],
    ['2 (Limited)', '11-18 pts', 'Basic communication is possible but limited'],
    ['1 (Weak)', '1-10 pts', 'Meaning is difficult to convey'],
  ],
  scoreWritingLevels: [
    ['5 (Good)', '27-30 pts', 'Logical, specific essay with accurate grammar'],
    ['4 (Fair)', '22-26 pts', 'Overall good but partially underdeveloped'],
    ['3 (Limited)', '15-21 pts', 'Has basic structure but weak development'],
    ['2 (Weak)', '8-14 pts', 'Off-topic at times or unclear structure'],
    ['1 (Very Weak)', '1-7 pts', 'Almost no meaningful communication'],
  ],

  vocabPageTitle: '600 High-Frequency TOEFL Words - Meanings and Examples | Power TOEFL',
  vocabPageDesc: 'Learn 600 TOEFL words by category with instant meanings and examples.',
  vocabHeading: 'Essential TOEFL Vocabulary',
  vocabIntro: 'Study must-know vocabulary by category. Click to reveal meanings.',
  vocabShowAll: 'Show all',
  vocabHideAll: 'Hide all',
  vocabReset: 'Reset',
  vocabClickToReveal: 'Click to reveal meaning',
  vocabMotivation: 'Consistent repetition raises your TOEFL score.',
  vocabMyWords: 'My Vocabulary',
  vocabAddWord: 'Add Word',
  vocabAddWordPlaceholder: 'Enter an English word',
  vocabMyWordsEmpty: 'No words added yet. Add your first word above.',
  vocabDeleteWord: 'Delete',
  vocabLookingUp: 'Looking up...',
  vocabFlashcardStart: 'Start Flashcards',
  vocabFlashcardStop: 'Stop Flashcards',
  vocabFlashcardEmpty: 'Add some words first to start flashcards.',
  vocabFlashcardSpeed: 'Speed',
  vocabFlashcardSpeedSlow: 'Slow',
  vocabFlashcardSpeedNormal: 'Normal',
  vocabFlashcardSpeedFast: 'Fast',
  vocabFlashcardShuffle: 'Shuffle',
  vocabFlashcardPrev: 'Previous',
  vocabFlashcardNext: 'Next',
  vocabFlashcardFlip: 'Flip',
  vocabFlashcardProgress: '{current} / {total}',
  vocabQuizTitle: 'Vocabulary Quiz',
  vocabQuizDesc: 'Test synonyms and antonyms of learned words.',
  vocabQuizMode_synonym: 'Synonym Quiz',
  vocabQuizMode_antonym: 'Antonym Quiz',
  vocabQuizMode_mixed: 'Mixed Quiz',
  vocabQuizClose: 'Close',
  vocabQuizNoQuestions: 'Not enough quiz items in this category yet.',
  vocabQuizBack: 'Back',
  vocabQuizResult: 'Quiz Result',
  vocabQuizExcellent: 'Excellent!',
  vocabQuizGood: 'Great job. A little more practice and you are set.',
  vocabQuizKeepGoing: 'Keep going!',
  vocabQuizRetry: 'Retry',
  vocabQuizFindSynonym: 'Choose the synonym for the following word',
  vocabQuizFindAntonym: 'Choose the antonym for the following word',
  vocabQuizNext: 'Next',
  vocabQuizFinish: 'View Result',
  vocabQuizStart: 'Start Quiz',
  vocabCatNaturalScience: 'Natural Science',
  vocabCatSocialScience: 'Social Science',
  vocabCatHumanities: 'Humanities',
  vocabCatLifeScience: 'Life Science',
  vocabCatTechnology: 'Technology/Engineering',
  vocabCatAcademicGeneral: 'Academic General',

  tipsLCPageTitle: 'How to Raise TOEFL Listening Score | LC Training Routine - Power TOEFL',
  tipsLCPageDesc: 'Practical TOEFL Listening training for higher LC scores: note-taking for Conversations and Lectures, inference, and speaker attitude questions.',
  tipsLCHeading: 'TOEFL Listening Score Strategy',
  tipsLCIntro: 'Core strategies and practical routines for each TOEFL Listening part.',
  tipsLCPractice: 'Practice Listening Now',
  tipsLCPracticeDesc: 'Apply the strategy with a real practice test.',
  tipsLCStartTest: 'Start Listening Test',
  tipsRCPageTitle: 'TOEFL Reading Strategy - Academic Passage Playbook | Power TOEFL',
  tipsRCPageDesc: 'TOEFL Reading strategy for academic passages: time allocation, inference, and summary-question approach.',
  tipsRCHeading: 'TOEFL Reading Strategy',
  tipsRCIntro: 'A practical guide to TOEFL Reading passage strategy and timing.',
  tipsRCPractice: 'Practice Reading Now',
  tipsRCPracticeDesc: 'Apply the strategy with a real practice test.',
  tipsRCStartTest: 'Start Reading Test',
  tips7DayTitle: '7-Day Last-Minute Study Plan',
  tips7DayDesc: 'Maximize score with a focused final-week routine',
  tipsTrapTitle: 'Trap Pattern Guide',
  tipsTrapDesc: 'Learn the 5 most common trap patterns in advance',

  aboutPageTitle: 'About Power TOEFL - Free TOEFL Mock Tests and AI Study Tools',
  aboutPageDesc: 'Independent TOEFL iBT practice for the January 2026 format (50/30 Reading, Listen and Repeat, 1–6 bands). Not affiliated with ETS.',
  aboutHeading: 'Power TOEFL — Independent 2026-format TOEFL practice',
  aboutS1Title: 'What is Power TOEFL?',
  aboutS1Body: 'Power TOEFL is an independent online practice platform for the TOEFL iBT format that started on 21 January 2026. We provide section practice, 2026-length mocks, AI feedback, and a wrong-answer notebook. Content is original study material, not ETS official items. Listening uses browser TTS; Complete the Words is sentence multiple choice.',
  aboutS2Title: 'Who is it for?',
  aboutS2Body: 'Recommended for students preparing TOEFL for admissions, professionals targeting required scores, and independent learners who want structured practice.',
  aboutS3Title: 'Key Features',
  aboutFeature1: '2026-format Reading, Listening, Speaking, and Writing mocks (item counts and times)',
  aboutFeature2: 'Section-focused practice for Reading, Listening, Speaking, and Writing',
  aboutFeature3: 'AI-powered question generation and weakness analysis',
  aboutFeature4: 'Automatic wrong-answer notebook with spaced review',
  aboutFeature5: 'Score conversion chart and essential TOEFL vocabulary',
  aboutS4Title: 'Free vs Premium',
  aboutS4Body: 'Free includes mock tests, section practice, and score conversion. Premium adds unlimited AI generation, ad-free study, and full mock access.',
  aboutS5Title: 'Why scores improve',
  aboutS5Body: 'With spaced repetition, targeted weakness analysis, and realistic practice conditions, learners can build stable test performance over time.',
  aboutS6Title: 'Relationship with ETS',
  aboutS6Body: 'Power TOEFL is an independent learning platform and is not affiliated with or endorsed by ETS. TOEFL is a registered trademark of ETS.',
  aboutS7Title: 'Contact',
  aboutS7Body: 'For service inquiries, contact skdaks0731@gmail.com.',
  aboutCtaHeading: 'Start today',
  aboutCtaDesc: 'Try a free TOEFL practice test now.',
  aboutCtaStart: 'Start a mock test',
  aboutCtaPricing: 'View Premium Plans',

  catPageTitle: 'TOEFL Adaptive Test (CAT) - Auto Difficulty by AI | Power TOEFL',
  catPageDesc: 'TOEFL computer-adaptive practice test. AI automatically adjusts question difficulty based on your performance.',
  catHeading: 'Adaptive Test (CAT)',
  catIntro: 'Difficulty auto-adjusts to your accuracy. {count} questions per session.',
  catNote: "Note: After January 2026, official TOEFL iBT Reading and Listening use two-stage adaptive modules. This Practice CAT only adjusts difficulty as a study tool. It is not a replica of the official module structure.",
  catSelectSection: 'Select Section',
  catStartBtn: 'Start Adaptive Test',
  catLoading: 'Loading next question...',
  catNoMore: 'No more questions available',
  catComplete: 'Adaptive Test Complete',
  catAccuracy: 'Accuracy',
  catFinalLevel: 'Final difficulty',
  catTryAgain: 'Try Again',
  catViewResults: 'View Results',
  catNext: 'Next',
  catExplanation: 'Explanation',
  catStop: 'Stop',
  catPlayAudio: 'Play Audio',
  catReadingPassage: 'Reading Passage',

  pricingTitle: 'Power TOEFL Pro Pricing — $14.99/month | Compare Free vs Pro | 2026',
  pricingDesc: 'Compare Free and Pro plans: unlimited AI questions, ad-free study, full round unlocks, and premium analysis tools.',
  pricingSaveBadge: '30% off',
  pricingPerMonth: 'month',
  pricingSSL: 'Secure checkout',
  pricingCard: 'Card payment',
  pricingPaymentSuccess: 'Premium activated successfully! ',
  pricingPaymentCancelled: 'Payment was cancelled.',
  pricingLoginRequired: 'Login is required.',
  pricingPaymentError: 'Failed to create checkout session.',
  pricingCurrentPlan: 'Current plan',
  pricingFaqQ1: 'What is the difference between Free and Pro?',
  pricingFaqA1: 'Free includes core Reading/Listening practice. Pro adds unlimited AI mock tests, Speaking/Writing AI feedback, weakness analytics, and ad-free study.',
  pricingFaqQ2: 'How are refunds handled?',
  pricingFaqA2: 'Due to the nature of digital products, refunds are generally not available. Refunds may be provided only in exceptional cases required by law, duplicate charges, non-delivery of service, or major technical failures.',
  pricingFaqQ3: 'How do I cancel my subscription?',
  pricingFaqA3: 'You can cancel anytime from My Subscription. Access remains available until the current billing period ends.',
  pricingFaqQ4: 'What is the difference between Lifetime and annual Pro?',
  pricingFaqA4: 'Lifetime is a one-time purchase with permanent access. Annual Pro renews yearly.',

  grammarSystematic: 'Systematic grammar learning',
  grammarBookTitle: 'TOEFL Grammar Book',
  grammarBookDesc: 'Learn 20 essential TOEFL grammar topics with practical examples and exercises.',
  grammarTestAfter: 'Test it right after studying!',
  grammarTestAfterDesc: 'Check how grammar points appear in real TOEFL questions.',
  grammarMockTest: 'Mock Test',
  grammarDoneTitle: 'Finished grammar study?',
  grammarDoneDesc: 'Apply what you learned in a mock test. Wrong answers are automatically saved for review.',
  grammarStartRC: 'Start Reading Mock Test',
  grammarPracticePart5: 'Reading Grammar Practice',
  grammarCourseName: 'TOEFL Grammar Complete Guide',
  grammarBreadcrumb: 'Grammar Book',

  leaderboardTitle: 'Study Leaderboard',
  leaderboardWeekly: 'Weekly',
  leaderboardMonthly: 'Monthly',
  leaderboardLoading: 'Loading...',
  leaderboardEmpty: 'No data for this {period} yet.',
  leaderboardEmptyWeek: 'week',
  leaderboardEmptyMonth: 'month',
  leaderboardHint: 'Solve tests and get listed automatically!',
  leaderboardRank: 'Rank',
  leaderboardNickname: 'Nickname',
  leaderboardSolved: 'Solved',
  leaderboardAccuracy: 'Accuracy',
  leaderboardMe: 'Me',
  leaderboardMyRank: '🏅 My rank: #{rank}',

  speakingPageH1: 'TOEFL Speaking Practice 2026',
  speakingPageSub: '{count}+ free speaking prompts — Listen and Repeat and Interview, with sample answers',
  speakingPageTitle: 'TOEFL Speaking Practice 2026 - {count}+ Free Prompts & Sample Answers | Power TOEFL',
  speakingPageDesc: '{count}+ TOEFL speaking prompts with sample answers, scoring rubrics, and AI feedback. Updated for 2026.',
  speakingAllTasks: 'All',
  speakingNoPrompts: 'No speaking prompts yet',
  speakingNoPromptsSub: 'Prompts are being generated. Please check back soon.',
  speakingResponseTime: 'Response time',

  writingPageH1: 'TOEFL Writing Practice 2026',
  writingPageSub: '{count}+ free writing tasks — Build a Sentence, Email, and Academic Discussion',
  writingPageTitle: 'TOEFL Writing Practice 2026 - {count}+ Free Tasks | Power TOEFL',
  writingPageDesc: '{count}+ TOEFL writing tasks with sample responses and scoring guides. Updated for 2026.',
  writingAllTasks: 'All',
  writingNoPrompts: 'No writing prompts yet',
  writingNoPromptsSub: 'Prompts are being generated. Please check back soon.',

  testPrevious: 'Previous',
  testNext: 'Next',
  testQuestion: 'Question',
  testQuestionPrompt: 'Read the question and choose the best answer.',
  testMarkAnswer: 'Please mark the best answer number.',
  testSelect: 'Select',
  testShowAnswer: 'Show answer and explanation',
  testCorrect: 'Correct!',
  testIncorrect: 'Incorrect.',
  testSubmit: 'Submit Test',
  testContinue: 'Continue',

  resultsTitle: '{0} Test Result',
  resultsTimeUsed: 'Time used: {0}m {1}s',
  resultsEstimatedScore: 'Estimated score (out of 30)',
  resultsCorrect: 'Correct',
  resultsIncorrect: 'Incorrect',

  // === Auto-translated from ko.ts (filling missing keys) ===
  navFAQ: `FAQ`,
  navReading: `Reading`,
  navListening: `Listening`,
  vocabSynonyms: `Synonyms`,
  vocabAntonyms: `Antonyms`,
  tipsLCButton: `Listening Strategy`,
  tipsRCButton: `Reading Strategy`,
  practiceRelatedLinks: `📌 Related study content`,
  practiceOtherParts: `Other parts`,
  practiceMockTestCTA: `Practice with a full mock test`,
  practiceTipsLink: `View part-specific strategies`,
  practiceGrammarLink: `Study grammar`,
  practiceNotFound: `Part not found.`,
  practiceQuestionType: `Question type`,
  practiceTips: `💡 Strategy tips`,
  practiceExamples: `📝 Example questions`,
  practiceIntro: `📋 Part overview`,
  practiceCommonTypes: `📊 Common question types`,
  practiceStrategy: `🎯 Key strategies`,
  practiceRecommendedFor: `👤 Recommended for`,
  practiceFAQ: `❓ FAQ`,
  practiceCTA: `Practice now`,
  practiceCTADesc: `You can practice Part {0} in a realistic test environment.`,
  practiceStartTest: `Start {0} mock test`,
  practiceQuestions: `Questions`,
  practicePartSelect: `Select part`,
  roundsTitle: `Mock test rounds`,
  roundLabel: `TOEFL Mock Test`,
  roundUnit: `round`,
  comingSoon: `Coming soon`,
  testLoginPrompt: `Wrong-answer notes & resume features require login.`,
  testGoogleLogin: `Start with Google in 3 seconds`,
  roundSelect: `Select another round`,
  testAnswered: `Answered`,
  testSubmitTitle: `Submit {0} test?`,
  testSubmitDesc: `You answered {1} out of {0} questions.`,
  testUnanswered: `{0} unanswered questions.`,
  testCannotUndo: `This action cannot be undone.`,
  testSubmitBtn: `Submit`,
  resultsAccuracy: `Accuracy`,
  resultsReview: `Review answers`,
  resultsYourAnswer: `Your answer: {0}`,
  resultsCorrectAnswer: `Correct answer: {0}`,
  resultsNoAnswer: `No answer`,
  resultsHome: `Home`,
  resultsWrongNotes: `Wrong Answers`,
  resultsRetry: `Retry`,
  resultsShare: `Share results`,
  resultsShareText: `My estimated TOEFL {0} score is {1}! ({2}/{3} correct, {4}% accuracy) Test your skills for free with Power TOEFL!`,
  resultsShareCopied: `Results copied to clipboard!`,
  resultsNoResults: `No test results.`,
  resultsGoHome: `Go home`,
  resultsSaved: `{0} wrong answers saved to your wrong answers`,
  wrongAnswersTitle: `Wrong Answers`,
  wrongAnswersSaved: `Saved items`,
  wrongAnswersHome: `Home`,
  wrongAnswersPracticeAll: `Practice all`,
  wrongAnswersAll: `All`,
  wrongAnswersNoItems: `No wrong answers yet. Take a test first!`,
  wrongAnswersYourAnswer: `Your answer: {0}`,
  wrongAnswersCorrectIs: `Correct answer: {0}`,
  wrongAnswersReviewed: `Reviewed`,
  wrongAnswersRemoved: `Removed from wrong answers`,
  wrongAnswersPracticeMode: `Practice mode`,
  wrongAnswersCorrectMsg: `Correct!`,
  wrongAnswersIncorrectMsg: `Incorrect. Correct answer: {0}`,
  wrongAnswersNextQuestion: `Next question`,
  wrongAnswersFinish: `Finish practice`,
  wrongAnswersExitPractice: `Exit practice`,
  wrongAnswersPracticeComplete: `Practice complete!`,
  wrongAnswersNoPractice: `No wrong answers to practice`,
  wrongAnswersLimitNotice: `Only the most recent 500 wrong answers are shown.`,
  privacyPageTitle: `Privacy Policy — Power TOEFL`,
  privacyPageDesc: `Power TOEFL Privacy Policy.`,
  privacyHeading: `Privacy Policy`,
  privacyLastUpdated: `Last updated: March 29, 2026`,
  privacyS1Title: `1. Collected personal information`,
  privacyS1Body: `Power TOEFL collects your email address, name, and profile photo when you sign in with Google to provide the service. When you make payments, payment information is processed via payment providers (Dodo Payments/PayPal); we do not store payment card details directly.`,
  privacyS2Title: `2. Purpose of use`,
  privacyS2Body: `Collected personal data is used only for saving wrong answers, tracking study progress, managing subscriptions, customer support, and improving the service.`,
  privacyS3Title: `3. Data retention and deletion`,
  privacyS3Body: `When a user deletes their account, personal data is deleted immediately. Payment records are retained up to 5 years as required by tax law and then deleted. If other laws require retention, data will be kept for the required period and then deleted.`,
  privacyS4Title: `4. Third-party disclosure`,
  privacyS4Body: `To process payments, we share the minimum required information (email) with Dodo Payments (Merchant of Record) or PayPal. We do not provide user personal data to other third parties except when required by law.`,
  privacyS5Title: `5. Cookies & ads`,
  privacyS5Body: `This site serves ads via Google AdSense. Third-party vendors, including Google, use cookies to serve personalized ads based on your prior visits to this and other websites. Google's use of advertising cookies enables it and its partners to show ads tailored to your browsing history. You may opt out of personalized advertising via Google Ads Settings (google.com/settings/ads), or opt out of third-party vendor cookies at www.aboutads.info. Cookies can also be managed in your browser settings. For details, see Google's Privacy Policy.`,
  privacyS6Title: `6. International data transfers`,
  privacyS6Body: `This service uses servers located abroad, and data may be transferred internationally for payment processing. We protect personal data with appropriate security measures.`,
  privacyS7Title: `7. User rights`,
  privacyS7Body: `Users may request access, correction, or deletion of their personal data at any time. EU/EEA residents have additional rights under GDPR. To delete your account, please log out and contact us.`,
  privacyS8Title: `8. Contact`,
  privacyS8Body: `For privacy inquiries, please contact skdaks0731@gmail.com.`,
  termsPageTitle: `Terms of Service — Power TOEFL`,
  termsPageDesc: `Power TOEFL Terms of Service.`,
  termsHeading: `Terms of Service`,
  termsLastUpdated: `Last updated: July 15, 2026`,
  termsS1Title: `1. Service overview`,
  termsS1Body: `Power TOEFL is an online learning platform for TOEFL preparation. Our registered legal business name is 'ddookddak'. We offer free features and paid premium subscriptions (Pro/Lifetime) that include mock tests, part-specific practice, AI question generation, and wrong-answer notes.`,
  termsS2Title: `2. Eligibility`,
  termsS2Body: `The service is available to users aged 14 and above. Some features (wrong-answer notes, AI practice, etc.) require Google account login, and premium features require a paid subscription.`,
  termsS3Title: `3. Intellectual property`,
  termsS3Body: `Content on this site (questions, design, code, etc.) is owned by Power TOEFL. TOEFL is a registered trademark of ETS; this site is not affiliated with ETS.`,
  termsS4Title: `4. Paid services & payments`,
  termsS4Body: `Premium subscriptions are processed via third-party payment services (Dodo Payments/PayPal). Subscription fees are charged automatically or as a one-time payment depending on the selected plan (monthly/annual/lifetime). Prices may include VAT; the final amount is shown at checkout. See the separate refund policy for refund details.`,
  termsS5Title: `5. Disclaimer`,
  termsS5Body: `Mock test scores and study materials provided by this service are for reference only and do not guarantee actual TOEFL results. We are not liable for direct or indirect damages resulting from use of the service.`,
  termsS6Title: `6. Prohibited conduct`,
  termsS6Body: `You may not copy or distribute questions without permission, overload the system, share accounts with others, or engage in other illegal activities.`,
  termsS7Title: `7. Service changes & suspension`,
  termsS7Body: `The operator may change or suspend the service without prior notice and is not required to provide compensation.`,
  termsS8Title: `8. Subscription cancellation`,
  termsS8Body: `Paid subscriptions can be canceled at any time. After cancellation, premium features remain available until the end of the paid period, after which the account will revert to the free plan.`,
  termsS9Title: `9. Changes to the terms`,
  termsS9Body: `These terms may be updated as needed; changes will be posted on the site. Continued use of the service after changes constitutes acceptance of the updated terms.`,
  refundPageTitle: `Refund Policy — Power TOEFL`,
  refundPageDesc: `Power TOEFL premium subscription refund policy.`,
  refundHeading: `Refund Policy`,
  refundLastUpdated: `Last updated: July 15, 2026`,
  refundS1Title: `1. Refund principle`,
  refundS1Body: `Due to the nature of digital products, refunds are generally not available.`,
  refundS2Title: `2. Exceptional refund cases`,
  refundS2Body: `Refunds may be provided only where required by applicable law or when duplicate charges, non-delivery of service, or major technical failures are confirmed.`,
  refundS3Title: `3. How to contact us`,
  refundS3Body: `Please use our support/feedback channel for refund-related inquiries. Contact: skdaks0731@gmail.com`,
  refundS4Title: `4. Subscription cancellation`,
  refundS4Body: `Paid subscriptions can be canceled at any time. After cancellation, premium access remains available until the end of the current billing period, and no further charges will be made.`,
  refundS5Title: ``,
  refundS5Body: ``,
  refundS6Title: ``,
  refundS6Body: `For refund inquiries, contact skdaks0731@gmail.com. We will respond within 1-2 business days.`,
  footerPrivacy: `Privacy Policy`,
  footerTerms: `Terms of Service`,
  footerRefund: `Refund Policy`,
  footerAbout: `About`,
  footerGuide: `Study Guide`,
  resumeTest: `Resume`,
  resumeDesc: `{0} Round {1} — {2}/{3} questions`,
  progressLabel: `Progress`,
  timerLabel: `Time left`,
  timeUp: `Time is up!`,
  navHome: `Home`,
  navSettings: `Tips & Strategies`,
  grammarChapter: `Chapter`,
  aiPracticeTitle: `Generate unlimited AI TOEFL questions — choose part & difficulty for instant questions | Power TOEFL`,
  aiPracticeDesc: `Select a part and difficulty and AI will instantly generate TOEFL questions. Free practice questions with automatic explanations — get new questions every day.`,
  aiPracticeH1: `✨ AI TOEFL Question Generator`,
  aiPracticeSub: `AI generates TOEFL questions in real time at your chosen difficulty.`,
  aiPartLabel: `Part`,
  aiDiffLabel: `Difficulty`,
  aiBeginner: `Beginner (1.0–2.5)`,
  aiIntermediate: `Intermediate (3.0–4.5)`,
  aiAdvanced: `Advanced (5.0–6.0)`,
  aiGenerate: `Generate questions`,
  aiGenerating: `Generating...`,
  aiRemainingToday: `{0} left this month`,
  aiLimitReached: `You've used all AI credits for this month`,
  aiLimitUpgrade: `Buy more credits or upgrade your plan!`,
  aiUpgrade: `Upgrade`,
  aiListenPrompt: `🔊 For Listening questions, listen to the audio while answering`,
  aiPlayAudio: `Play audio`,
  aiStopAudio: `Stop`,
  aiCorrect: `✅ Correct!`,
  aiWrong: `❌ Incorrect.`,
  aiCorrectAnswer: `Correct answer: {0}`,
  aiPrev: `Previous`,
  aiNext: `Next`,
  aiNewQuestions: `New questions`,
  aiEmptyTitle: `Generate questions with AI`,
  aiEmptyDesc: `Select a part and difficulty, then press "Generate questions".`,
  aiLoadingMain: `AI is generating and validating questions...`,
  aiLoadingSub: `Takes about 10–20 seconds`,
  statsTitle: `TOEFL Study Statistics — Power TOEFL`,
  statsDesc: `See your TOEFL grammar quiz accuracy, wrong-answer review status, and other study stats at a glance.`,
  statsH1: `📊 Study Stats`,
  statsLoginPrompt: `Log in to view your study statistics.`,
  statsTotalQuizzes: `Total quizzes`,
  statsTotalQuestions: `Total questions`,
  statsAccuracy: `Accuracy`,
  statsLast7Days: `Last 7 days`,
  statsWrongSummary: `Wrong-answer summary`,
  statsViewAll: `View wrong answers`,
  statsTotalWrong: `Total wrong answers`,
  statsReviewed: `Reviewed`,
  statsPending: `Pending review`,
  statsTopicAccuracy: `Accuracy by grammar topic`,
  statsAttempts: `{0} attempts`,
  statsEmpty: `No study records yet. Try a grammar quiz!`,
  statsStartGrammar: `Start grammar study`,
  testLCTitle: `TOEFL Listening mock test free — conversations & lectures | 2026`,
  testLCDesc: `Free 2026 updated TOEFL Listening mock test. 20 questions from conversations and lectures. Wrong answers saved automatically.`,
  testRCTitle: `TOEFL Reading mock test free — academic passage reading | 2026`,
  testRCDesc: `Free 2026 updated TOEFL Reading mock test. 28 questions based on academic passages. AI explanations and wrong-answer notes provided.`,
  reviewTitle: `Today's review`,
  reviewDesc: `Smart review system based on the Ebbinghaus forgetting curve`,
  reviewSubtitle: `Review at the optimal times according to the forgetting curve`,
  reviewRemaining: `Remaining reviews`,
  reviewProgress: `Review progress`,
  reviewCompleted: `🎉 Today's review complete!`,
  reviewCompletedDesc: `Reviewed {0} questions`,
  reviewEmpty: `No review items for today`,
  reviewEmptyDesc: `Either you've completed all reviews or there are no wrong answers yet.`,
  reviewStage: `Stage {0}`,
  reviewNextInterval: `{0}-day interval`,
  reviewCorrect: `Correct! Move to the next stage.`,
  reviewWrong: `Incorrect. Restarting at stage 1.`,
  reviewNextReview: `Next review: in {0} days`,
  reviewResetMsg: `Incorrect — you'll review again in 1 day.`,
  reviewNext: `Next question`,
  reviewFinish: `Finish`,
  reviewHowItWorks: `Ebbinghaus review method`,
  reviewDaysLater: `{0} days later`,
  reviewExplanation: `Incorrect items are reviewed at intervals of 1 → 3 → 7 → 14 → 30 → 60 days. Correct answers move to the next stage; incorrect answers return to stage 1.`,
  notifTitle: `Notifications`,
  notifEmpty: `No new notifications`,
  notifMarkAllRead: `Mark all as read`,
  timeJustNow: `Just now`,
  timeMinutes: `{0} minutes ago`,
  timeHours: `{0} hours ago`,
  timeDays: `{0} days ago`,
  scoreCardEstimated: `Estimated score`,
  scoreCardCorrect: `Correct`,
  scoreCardIncorrect: `Incorrect`,
  scoreCardAccuracy: `Accuracy`,
  pushTitle: `Get study notifications`,
  pushDesc: `We notify you about review times, streaks, and more.`,
  pushEnable: `Enable notifications`,
  navReview: `Review`,
  navStats: `Stats`,
  navSubscription: `Subscription`,
  roundDetailHeading: `TOEFL Full Mock Test`,
  roundDetailOtherRounds: `View other rounds`,
  roundDetailBreadcrumbMockTest: `Mock test rounds`,
  roundDetailLearningPoints: `Learning points for this round`,
  roundDetailRelatedRounds: `Similar difficulty rounds`,
  roundDetailBackToHub: `← All mock test rounds`,
  recTabTitle: `Recommended rounds`,
  recBeginner: `Beginner (section 15 target)`,
  recIntermediate: `Intermediate (section 22 target)`,
  recAdvanced: `Advanced (section 28 target)`,
  recScore300: `Target total 40–70`,
  recScore500: `Target total 70–95`,
  recScore700: `Target total 95–120`,
  recFullMock: `Full Reading + Listening set`,
  recTrap: `Trap-style items`,
  recWeakness: `Weakness review`,
  recRecommended: `Latest recommended`,
  recPointSuffix: `/30`,
  recQuestionSuffix: ` questions`,
  recPartLabels: `Reading,Conversations,Lectures`,
  mockTestHubTitle: `Free TOEFL mock tests — Tiered rounds | Power TOEFL`,
  mockTestHubDesc: `Practice TOEFL iBT skills with tiered Power TOEFL rounds. Question counts and composition follow current operating settings, with AI explanations included.`,
  mockTestHubH1: `🎯 Free TOEFL mock tests — by difficulty tier`,
  mockTestHubIntro: `Choose beginner, intermediate, or advanced Power TOEFL practice rounds. Question counts and composition vary by current operating settings and may differ from the exact current official exam format.`,
  mockTestHubWhyTitle: `Why Power TOEFL tiered mock tests?`,
  mockTestHubWhy1: `Fresh AI-generated items every week`,
  mockTestHubWhy2: `Three difficulty tiers matched to your target score`,
  mockTestHubWhy3: `Unique study guides per round for SEO-rich, crawlable content`,
  mockTestHubWhy4: `Wrong-answer notes plus section weakness analysis`,
  mockTestHubHowTitle: `How to use them`,
  mockTestHubHow1: `1️⃣ Pick a tier tab that matches your goal score`,
  mockTestHubHow2: `2️⃣ Read the round study guide, then start Reading or Listening`,
  mockTestHubHow3: `3️⃣ Review AI analysis after each attempt`,
  mockTestHubHow4: `4️⃣ Repeat with other rounds at the same tier`,
  mockTestHubFaq1Q: `How many questions per round?`,
  mockTestHubFaq1A: `Question counts are provided per round based on current operating settings. Check each round detail page for exact counts. Speaking and Writing are on separate practice pages.`,
  mockTestHubFaq2Q: `How many rounds are free?`,
  mockTestHubFaq2A: `All rounds are free with a daily limit. Pro members get unlimited attempts.`,
  mockTestHubFaq3Q: `How are difficulty tiers defined?`,
  mockTestHubFaq3A: `Beginner targets section score 15, intermediate 22, advanced 28. Each round page includes tier-specific study content.`,
  mockTestHubFaq4Q: `Where do I see my results?`,
  mockTestHubFaq4A: `After submitting, the results page shows estimated scores and section accuracy. Log in to save history.`,
  mockTestHubAllRounds: `All mock test rounds`,
  mockTestHubEmpty: `No rounds available yet`,
  mockTestHubEmptyDesc: `AI adds new rounds every week. In the meantime, try section practice.`,
  mockTestHubLoading: `…`,
  popularTestsTitle: `🏆 Popular TOEFL Mock Tests`,
  sectionSections: `Sections`,
  roundDetailStrategyTitle: `Section strategies for this round`,
  navSitemap: `Sitemap`,
  navFaq: `FAQ`,
  roundSuffix: `round`,
  footer7DayPlan: `7-day study plan`,
  footerTrapPatterns: `Trap patterns`,
  pwaAddToHome: `📱 Add to Home Screen`,
  pwaAddToHomeDesc: `Launch like an app! Study offline too`,
  pwaInstall: `Install`,
  pwaIOSGuide: `Share → Add to Home Screen`,
  aiQuizTitle: `🤖 AI Custom Practice Questions`,
  aiQuizDesc: `AI-generated TOEFL grammar questions`,
  aiQuizGenerateDesc: `AI generates 5 TOEFL-style grammar questions in real time.`,
  aiQuizGenerate: `Generate AI questions`,
  aiQuizGenerating: `🤖 AI is generating questions...`,
  aiQuizGeneratingTime: `Takes about 5–10 seconds`,
  aiQuizNew: `New questions`,
  aiQuizStats: `Cumulative stats:`,
  aiQuizTimes: `times`,
  aiQuizCheckAnswers: `Check answers`,
  aiQuizPerfect: `🎉 Perfect!`,
  aiQuizCorrectCount: `Correct`,
  aiQuizSaving: `Saving results...`,
  aiQuizTryNew: `Try new questions`,
  aiQuizError: `Failed to generate AI questions. Please try again.`,
  tipsDetailStrategy: `Detailed strategy`,
  subLoginRequired: `Login required.`,
  grammarHome: `Home`,
  grammarExamples: `Example sentences`,
  grammarTestKnowledge: `📝 Skill test`,
  grammarTestKnowledgeDesc: `Try real questions related to the grammar you just learned!`,
  grammarCheckAnswers: `Check answers`,
  grammarPerfect: `🎉 Perfect!`,
  grammarCorrectCount: `Correct`,
  grammarMockCTA: `🔥 Verify your skills with a full mock test!`,
  grammarMockCTADesc: `RC 100-question full mock test + automatic wrong-answer notes`,
  grammarStartRCMock: `Start RC mock test`,
  grammarPractice5: `Reading practice`,
  grammarTestInPractice: `Check it in practice!`,
  grammarTestInPracticeDesc: `See how grammar points appear on real TOEFL tests.`,
  grammarRelated: `📚 Related grammar`,
  wrongAnswersGrammarAI: `Grammar AI`,
  streakDays: `days`,
  streakLabel: `Study streak`,
  streak7: `7-day streak!`,
  streak14: `2-week streak!`,
  streak30: `Amazing! 30-day streak!`,
  reviewItems: `items`,
  reviewTodayLabel: `Today's review questions`,
  reviewGoLabel: `📚 Start review →`,
  loadingQuestions: `Loading questions...`,
  tipsCoreTips: `Core tips`,
  tipsStrategy: `Strategy`,
  tipsCTA: `Apply these strategies in practice!`,
  testScrollHint: `Scroll to view the question and options`,
  testPart1Label: `Academic Reading`,
  testPart2Title: `Conversations`,
  testPart2Desc: `Listen to the audio and choose the correct answer`,
  testPart3Label: `Lectures`,
  creditBuyBtn: `Buy credits`,
  creditBuyTitle: `Buy AI credits`,
  creditBuyDesc: `Buy extra credits for Speaking/Writing AI feedback and AI practice.`,
  creditBuyError: `Failed to initiate payment`,
  creditBuyNote: `PayPal payment. Credits are added immediately after payment completes.`,
  creditUnit: `credits`,
} as typeof ko;

export default en;
